@use "~theme/typography";

.container {
  animation-name: fanfare-keyframes;
  animation-delay: 0.8s;
  animation-duration: 5s;
  animation-iteration-count: 1;
  opacity: 0;

  background-color: var(--blue-02);
  border-radius: 4px;
  display: inline-flex;
  align-items: flex-start;
  padding: 16px 20px 16px 14px;

  &::before {
    content: "";
    position: absolute;
    right: 20px;
    bottom: -10px;
    height: 28px;
    width: 28px;
    clip-path: polygon(20% 20%, 80% 80%, 0% 100%);
    transform: rotate(-45deg);
    background-color: var(--blue-02);
    border-radius: 4px;
  }
}

.icon {
  margin-right: 16px;
}

.message {
  @include typography.body;
  color: var(--white);
  margin: 0;
}

@keyframes fanfare-keyframes {
  // Bounce in from below
  0% {
    animation-timing-function: cubic-bezier(0.38, 1.52, 0.38, 1.56);
    opacity: 0;
    transform: translateY(140px);
  }

  6% {
    opacity: 1;
    transform: translateY(0);
  }

  // And then fade out
  96% {
    animation-timing-function: ease-out;
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
